import { render, staticRenderFns } from "./InputParameterList.vue?vue&type=template&id=0acb5148"
import script from "./InputParameterList.vue?vue&type=script&lang=js"
export * from "./InputParameterList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports